<template>
    <div class="content">
        <div class="content_quan"></div>
        <div id="caseDetailPages">
            <div class="content_top">
                <img src="https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/case/details/detail-title-back-icon2.png" alt="">
                <div>用户真实安装实例</div>
            </div>
            <div class="warp">
                <div class="warp_img">
                    <div class="tips">{{topicDetails.new_scenes[0].scenes_name+'场景'}}</div>
                    <img :src="topicDetails.new_scenes[0].house_img[0].img_base_url" />
                </div>
                <div class="topic_content">
                    <div class="city">
                        {{topicDetails.province_name + topicDetails.plot.city + topicDetails.plot.district + topicDetails.plot.name}}
                    </div>
                    <div class="system">
                        {{topicDetails.tagsArr}}
                    </div>
                    <div class="text">
                        {{oDetailsObj.constructor == Array?'':oDetailsObj.score.content}}
                    </div>
                    <div class="code">
                        <div class="code_warp">
                            <div class="code_img">
                                <img :src="codeImg" />
                            </div>
                            <div class="code_img_text">扫码查看更多案例</div>
                        </div>
                        <div class="logo_img">
                            <img src="@/assets/images/case/lan_logo.png" />
                        </div>
                    </div>
                </div>
                <img class="sImg" v-if="sImg != ''" :src="sImg" alt="">
            </div>
        </div>
    </div>
</template>

<script>
import html2canvas from "@/libsV2/html2canvas";
import path from "@/path.js";
import { requestAesPost5 } from "@/libsV2/requestAes";
export default {
    data() {
        return {
            codeImg: "",
            oDetailsObj: {
                score: {
                    content: "",
                },
            },
            topicDetails: {
                province_name:'',
                tagsArr: "",
                plot: {
                    city: "",
                    district: "",
                    name: "",
                },
                new_scenes: [{ house_img: [{ img_base_url: "" }] }],
            },
            sImg: "",
            Loop: "",
        };
    },
    mounted() {
        this.getDetails();
    },
    methods: {
        // 判断产品名称
        getGoodsName(data = {}){
            let arrGoodsName = [
                {
                    goods_name:'软水美容燃气热水器',
                    arr: ['JSQ31-RJS','JSQ31-RJS(X)','JSQ31-RSC(X)']
                },
                {
                    goods_name:'「瀞」油烟机',
                    arr: ['CXW-200-S5','CXW-200-S7','CXW-200-S9']
                },
                {
                    goods_name:'橱下冷热即饮净水机',
                    arr: ['DR1600HA1','DR1800HA1','DR2000HA9','DR1600HF2','DR1800HF2','DR2000HF1','DR2000HF2','DR1600HB7']
                }
            ]
            let goodsTypeName = arrGoodsName.find(it=>{
                return it.arr.includes(data.goods_name);
            })
            return goodsTypeName != undefined?goodsTypeName.goods_name : data.goods_type_name;
        },
        getDetails() {
            let data = {
                topic_id: this.$route.query.topic_id,
                source: "xcx",
                user_id: this.$route.query.user_id,
                is_share: 0,
            };
            this.$store.commit("loadSwitch", true);
            requestAesPost5(path.TOPIC_AES_TOPIC, data).then(async (res) => {
                if (res.data.error == 0) {
                    let arrGoods = [];
                    res.data.data.result.new_scenes.forEach((it) => {
                        let arrGoodsText = it.goods_info.map(item=>{
                            return this.getGoodsName(item)
                        }).filter(l => l != undefined);
                        arrGoods = arrGoods.concat(arrGoodsText);
                    });
                    res.data.data.result.tagsArr = arrGoods.join(" · ");
                    this.topicDetails = res.data.data.result;
                    console.log(this.topicDetails.new_scenes[0]);
                    requestAesPost5(path.TOPIC_AES_DETAIL, data).then(
                        (_result) => {
                            this.oDetailsObj = _result.data.data.result;
                            requestAesPost5('comm/qrcode/get', {
                                type: 1,
                                // version:'trial',// 生成体验版码
                                page: 'praise/pages/case/detail/index',
                                param:`user_id=${this.$route.query.user_id}%topicid=${this.$route.query.topic_id}&id=${this.$route.query.topic_id}&cource=xcx&track_action=topic_share&track_id=${this.$route.query.topic_id}&track_uuid=${this.$route.query.track_uuid}&bEmpower=${this.$route.query.bEmpower}&shareEmpowerName=${this.$route.query.shareEmpowerName}`,
                            }).then((code) => {
                                this.codeImg = code.data.data.result.url;
                                let newImage = new Image();
                                newImage.onload = () => {
                                    this.$nextTick(() => {
                                        html2canvas(
                                            document.querySelector(
                                                "#caseDetailPages"
                                            ),
                                            {
                                                useCORS: true,
                                                backgroundColor: null,
                                            }
                                        ).then((c) => {
                                            wx.miniProgram.postMessage({
                                                data: { base64: c.toDataURL() },
                                            });
                                            console.log(c.toDataURL())
                                            wx.miniProgram.navigateBack();
                                            // this.sImg = c.toDataURL();
                                            this.$store.commit("loadSwitch", false);
                                        });
                                    });
                                }
                                newImage.src = code.data.data.result.url;
                                // console.log(this.oDetailsObj, "09");
                            });
                        }
                    );
                } else {
                    this.$toast({
                        message: res.data.msg,
                        duration: 500,
                    });
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.content_quan {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    background: #fff;
    z-index: 22;
}
.sImg {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
}
.content {
    width: 100%;
    background: #f7f7f7;
    .content_top {
        width: 100%;
        height: 84px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: white;
        font-weight: 500;
        padding: 0 28px;
        line-height: 40px;
        font-size: 28px;
        position: relative;
        div{
            position: absolute;
            z-index: 2;
        }
        img{
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
        }
    }
    .warp {
        width: 100%;
        margin: 0 auto 0;
        border-radius: 0 0 12px 12px;
        overflow: hidden;
        background: #fff;
        position: relative;
        .warp_img {
            width: 100%;
            max-height: 545px;
            overflow: hidden;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            .tips {
                color: white;
                padding: 0 24px 0 54px;
                position: absolute;
                min-width: 182px;
                bottom: 0;
                right: 0;
                font-size: 24px;
                line-height: 58px;
                background: url(https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/case/details/scen-t-icon.png)
                    no-repeat left top/100% 58px;
                z-index: 10;
            }
            img {
                width: 100%;
            }
        }
        .topic_content {
            padding: 10px 24px;
            box-sizing: border-box;
            .city {
                font-size: 38px;
                font-weight: 400;
                color: #318544;
                line-height: 48px;
            }
            .system {
                font-size: 28px;
                font-weight: 400;
                color: #858585;
                line-height: 38px;
                margin-top: 4px;
            }
            .text {
                text-indent: 56px;
                font-size: 35px;
                text-align: justify;
                font-weight: 400;
                color: #4b4b4b;
                line-height: 48px;
                margin-top: 10px;
                letter-spacing: 0.1px;
            }
        }
        .code {
            padding: 22px 0;
            box-sizing: border-box;
            width: 100%;
            border-top: 2px solid #f7f7f7;
            margin-top: 32px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .code_img {
                width: 128px;
                height: 128px;
                img {
                    width: 100%;
                    height: 100%;
                }
            }
            .code_warp {
                display: flex;
                align-items: center;
            }
            .code_img_text {
                font-size: 24px;
                font-weight: 400;
                color: #999999;
                line-height: 34px;
                margin-left: 20px;
            }
            .logo_img {
                width: 200px;
                img {
                    width: 100%;
                }
            }
        }
    }
}
</style>
